import React, { useRef } from 'react';
import { Skeleton } from '@material-ui/lab';
import styled from 'styled-components';
const PDFPagePlaceholder = styled.div `
    height: ${(props) => (props.height ? `${props.height}px` : '60rem')};
    background-color: transparent;
`;
const PDFDocument = ({ DocumentComponent, PageComponent, url, handleLoadSuccess, page, totalPages, setPage, scale }) => {
    var _a;
    const canvasRef = useRef(null);
    const handleLoadError = (error) => {
        console.error(error);
    };
    const onItemClick = (item) => {
        const pageNumber = Number(item === null || item === void 0 ? void 0 : item.pageNumber);
        if (pageNumber <= totalPages && pageNumber > 0) {
            setPage(pageNumber);
        }
    };
    return (React.createElement(DocumentComponent, { externalLinkTarget: "_blank", file: url, onLoadSuccess: handleLoadSuccess, inputRef: canvasRef, onLoadError: handleLoadError, onItemClick: onItemClick, loading: React.createElement(Skeleton, { variant: "rect", animation: "wave", height: "60rem", width: "100%", style: { marginBottom: '1rem' } }), error: React.createElement("p", null, "There was an error loading this PDF") },
        React.createElement(PageComponent, { scale: scale !== null && scale !== void 0 ? scale : 1, pageNumber: page, loading: React.createElement(PDFPagePlaceholder, { height: (_a = canvasRef === null || canvasRef === void 0 ? void 0 : canvasRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight }) })));
};
export default PDFDocument;
//# sourceMappingURL=PDFDocument.js.map